<template>
  <div class="query-form">
    <el-form :inline="true" :model="form" class="form" ref="form">
      <el-form-item label="对账日期" class="item-date" prop="datePicker">
        <el-date-picker
          v-model="form.datePicker"
          :editable="false"
          value-format="yyyy-MM-dd"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item v-for="item of formList" :key="item.label" :label="item.label" :prop="item.prop">
        <el-select v-model="form[item.prop]" placeholder="请选择">
          <el-option v-for="el in item.options" :key="el.key" :label="el.key" :value="el.value"> </el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="item-type">
        <el-button type="primary" @click="submitForm(form)">查询</el-button>
        <el-button @click="resetForm">重置</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: 'queryForm',
  inject: {
    submitForm: 'submit',
    formList: 'formList',
  },
  data() {
    return {
      form: {
        datePicker: [],
        result1: null,
        result2: null,
      },
      options: [
        {
          label: '差错一',
          value: 1,
        },
      ],
      types: [
        {
          label: '差错一',
          value: 1,
        },
      ],
    };
  },
  methods: {
    resetForm() {
      this.$refs.form.resetFields();
    },
  },
};
</script>

<style lang="less" scoped>
@import '~@/assets/style/mixins.less';
@import '~@/assets/style/var.less';

// 重写 element-ui 样式
.el-form-item {
  margin: 0;
}
/deep/.el-form-item__label {
  color: @font-color-black;
}
.el-date-editor .el-range__icon {
  display: none;
}
.el-button--primary {
  .button--primary(@primary-blue);
  margin-right: 20px;
}

// 正常样式
.query-form {
  padding: 20px;
  .reconciliation_list_space(@bg-white);
}
.item-date {
  margin-right: 40px;
  margin-bottom: 20px;
}
.item-type {
  margin-left: 30px;
}
</style>
